module.exports = __webpack_public_path__ + "img/safari3.cad7fe9a.png";